<!--顶部搜索-->
<template>
  <div class="type-header" @click="onSearch">
    <div>
      <img src="../assets/images/icon_search.png" alt />
      <p>搜索你想找的宝贝</p>
    </div>
  </div>
</template>
<style scope>
.type-header {
  padding: 10px 0;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background: #ffffff;
  z-index: 1;
}

.type-header div {
  width: 7.03rem;
  height: 30px;
  background: rgba(239, 239, 244, 1);
  border-radius: 5px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #bababa;
  font-size: 14px;
}

.type-header img {
  width: 16px;
  height: 16px;
  margin-right: 0.1rem;
}
</style>

<script>
export default {
  name: "HeadSearch",
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  mounted: function() {},
  methods: {
    onSearch() {
      let id = this.id;
      if (id) {
        rbLink({
          name: "BusinessSearch",
          query: { business_id: id }
        });
      } else {
        rbLink({
          name: "GoodsSearch",
          query: {}
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// HeadSearch.vue?3212f165